import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ExpTypeExtRouter } from './exp-type.router';
import { reducers } from './state/exp-type.selectors';

@NgModule({
  imports: [
    ExpTypeExtRouter,
    StoreModule.forFeature('expType', reducers),
  ],
  declarations: []
})
export class ExpTypeExtScreenModule { }